/* eslint-disable class-methods-use-this */
import { getOrThrow, GridUtils, TextCellRenderer } from '@deephaven/grid';
import { TableUtils } from '@deephaven/jsapi-utils';
import IrisGridCellRendererUtils from "./IrisGridCellRendererUtils.js";
class IrisGridTextCellRenderer extends TextCellRenderer {
  drawCellContent(context, state, column, row) {
    var _model$columns$modelC;
    var metrics = state.metrics,
      model = state.model;
    var modelColumns = metrics.modelColumns,
      modelRows = metrics.modelRows;
    var modelRow = getOrThrow(modelRows, row);
    var modelColumn = modelColumns.get(column);
    if (modelColumn === undefined) {
      return;
    }
    var value = model.valueForCell(modelColumn, modelRow);
    if (TableUtils.isTextType((_model$columns$modelC = model.columns[modelColumn]) === null || _model$columns$modelC === void 0 ? void 0 : _model$columns$modelC.type)) {
      if (value === null || value === '') {
        var originalFont = context.font;
        context.font = "italic ".concat(originalFont);
        super.drawCellContent(context, state, column, row);
        context.font = originalFont;
        return;
      }
    }
    super.drawCellContent(context, state, column, row);
  }

  // This will shrink the size the text may take when the overflow button is rendered
  // The text will truncate to a smaller width and won't overlap the button
  getTextRenderMetrics(state, column, row) {
    var textMetrics = GridUtils.getTextRenderMetrics(state, column, row);
    var mouseX = state.mouseX,
      mouseY = state.mouseY,
      metrics = state.metrics,
      theme = state.theme;
    if (mouseX == null || mouseY == null) {
      return textMetrics;
    }
    var _GridUtils$getGridPoi = GridUtils.getGridPointFromXY(mouseX, mouseY, metrics),
      mouseColumn = _GridUtils$getGridPoi.column,
      mouseRow = _GridUtils$getGridPoi.row;
    if (column === mouseColumn && row === mouseRow) {
      var _this$getCellOverflow = this.getCellOverflowButtonPosition(mouseX, mouseY, metrics, theme),
        left = _this$getCellOverflow.left;
      if (this.shouldRenderOverflowButton(state) && left != null) {
        textMetrics.width = left - metrics.gridX - textMetrics.x;
      }
    }
    return textMetrics;
  }
  getCellOverflowButtonPosition(mouseX, mouseY, metrics, theme) {
    var NULL_POSITION = {
      left: null,
      top: null,
      width: null,
      height: null
    };
    if (mouseX == null || mouseY == null || metrics == null) {
      return NULL_POSITION;
    }
    var _GridUtils$getCellInf = GridUtils.getCellInfoFromXY(mouseX, mouseY, metrics),
      rowHeight = _GridUtils$getCellInf.rowHeight,
      columnWidth = _GridUtils$getCellInf.columnWidth,
      left = _GridUtils$getCellInf.left,
      top = _GridUtils$getCellInf.top;
    if (left == null || columnWidth == null || top == null) {
      return NULL_POSITION;
    }
    var gridWidth = metrics.width,
      verticalBarWidth = metrics.verticalBarWidth;
    var cellHorizontalPadding = theme.cellHorizontalPadding,
      iconSize = theme.iconSize;
    var width = iconSize + 2 * cellHorizontalPadding;
    var height = rowHeight;
    // Right edge of column or of visible grid, whichever is smaller
    var right = Math.min(metrics.gridX + left + columnWidth, gridWidth - verticalBarWidth);
    var buttonLeft = right - width;
    var buttonTop = metrics.gridY + top;
    return {
      left: buttonLeft,
      top: buttonTop,
      width,
      height
    };
  }
  shouldRenderOverflowButton(state) {
    var _model$textForCell;
    var context = state.context,
      mouseX = state.mouseX,
      mouseY = state.mouseY,
      metrics = state.metrics,
      model = state.model,
      theme = state.theme;
    if (mouseX == null || mouseY == null) {
      return false;
    }
    var _GridUtils$getCellInf2 = GridUtils.getCellInfoFromXY(mouseX, mouseY, metrics),
      row = _GridUtils$getCellInf2.row,
      column = _GridUtils$getCellInf2.column,
      modelRow = _GridUtils$getCellInf2.modelRow,
      modelColumn = _GridUtils$getCellInf2.modelColumn;
    if (row == null || column == null || modelRow == null || modelColumn == null || model.columns[modelColumn] == null || !TableUtils.isStringType(model.columns[modelColumn].type)) {
      return false;
    }
    var text = (_model$textForCell = model.textForCell(modelColumn, modelRow)) !== null && _model$textForCell !== void 0 ? _model$textForCell : '';
    var _GridUtils$getTextRen = GridUtils.getTextRenderMetrics(state, column, row),
      textWidth = _GridUtils$getTextRen.width;
    var fontWidthLower = metrics.fontWidthsLower.get(theme.font);
    var fontWidthUpper = metrics.fontWidthsUpper.get(theme.font);
    context.save();
    context.font = theme.font;
    var truncatedText = this.getCachedTruncatedString(context, text, textWidth, fontWidthLower, fontWidthUpper, model.truncationCharForCell(modelColumn, modelRow));
    context.restore();
    return text !== '' && truncatedText !== text;
  }
  drawTreeMarker(context, state, columnX, rowY, treeBox, color, isExpanded) {
    IrisGridCellRendererUtils.drawTreeMarker(context, state, columnX, rowY, treeBox, color, isExpanded);
  }
}
export default IrisGridTextCellRenderer;
//# sourceMappingURL=IrisGridTextCellRenderer.js.map